// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8316":"eb687123","9415":"b44b5166"}[chunkId] + ".chunk.css";
};